// extracted by mini-css-extract-plugin
export var form = "_dk-0";